import React from "react";

export default function TransparentPricing({
  id,
  chipText = "How it Works",
  title = "Transparent Pricing And Clear Expectations",
}) {
  const cards = [
    {
      title: "Know What to Expect Before Work Begins",
      description:
        "Our system is built around smart technology to give you an estimated price range for repairs based upon the details you provide, recent similar jobs, local labor rates, and vendor pricing trends. This upfront range gives you the ability to make informed decisions without any surprises. Once the job is complete, you will only pay for the work that was done.",
    },
    {
      title: "There is No Substitute for Hands-on Diagnostic Experience",
      description:
        "In rare instances, a deeper issue is uncovered on site, such as a slow drain that turns out to be caused by a collapsed waste pipe, not a clog. In such cases, vendors report the findings, and Properteasy alerts you right away. We only move forward if you approve the additional work and revised estimate. You're always in control of what gets done, and just as importantly, what doesn't.",
    },
  ];

  return (
    <div id={id} className="lg:max-w-[1440px] w-full mx-auto">
      <div className="w-full md:px-12 px-5 mx-auto">
        <div className="w-full mx-auto flex flex-col gap-4 md:gap-8 lg:gap-[64px] text-white py-8 lg:py-[64px]">
          <div className="flex flex-col gap-3 md:gap-4 lg:gap-6">
            <h5 className="bg-[#3CAB5C1A] text-[#3CAB5C] px-3 py-1 rounded-full border border-[#3CAB5C] font-medium w-fit">
              {chipText}
            </h5>

            <h1 className="font-medium w-full text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]">
              {title}
            </h1>
          </div>
          <div className="flex gap-[10px] flex-col md:flex-row w-full">
            {cards.map((card, index) => (
              <div
                key={index}
                className="bg-[#F6F7F9] w-full p-6 rounded-[20px] items-center flex flex-col"
              >
                <h1 className="text-[#242424] w-full text-[24px] md:text-[36px] font-medium mb-4 md:mb-6">
                  {card.title}
                </h1>
                <h2 className="text-[#333333] w-full text-[18px] md:text-[22px]">
                  {card.description}
                </h2>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
